
import LazyHydrate from 'vue-lazy-hydration'
import { Component, Prop } from '~/utility/pu-class-decorator'
import { PitchType } from '~/apps/campsite-details/types'
import { SearchFilters } from '~/apps/search/schemas'
import { PitchTypePricingResult } from '~/apps/search/types'
import { isDateInSameYear, isDatePast } from '~/utility/date/relative'
import { SimpleMoney } from '~/utility/money'
import BaseCampsiteCard from './BaseCampsiteCard.vue'

@Component({
  components: {
    LazyHydrate,
  },
})
export default class PuCampsitePriceCard extends BaseCampsiteCard {
  @Prop()
    pitchtypes?: PitchTypePricingResult[] | PitchType[]

  @Prop()
    nextOpen: string

  @Prop()
    leadPrice: SimpleMoney

  @Prop()
    leadPriceNights: number

  @Prop({ required: false })
    searchFilters?: SearchFilters

  @Prop({ required: false })
    searchResultIndex: number

  numberOfPitchtypesToShow = 4

  showPitchesExpanded = false

  get shouldShowOpenDate() {
    return this.nextOpen && !isDatePast(this.nextOpen)
  }

  isDateInSameYear(date: string) {
    return isDateInSameYear(date)
  }

  get pitchtypesSectionId() {
    return `pitchtypes${this.searchResultIndex}`
  }

  get isDatedSearch() {
    return this.searchFilters && this.searchFilters.dates
  }

  showMorePitches() {
    this.showPitchesExpanded = !this.showPitchesExpanded
  }
}
